<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="grid"></action-toolbar-count>
            <action-toolbar-buttons
                [grid]="grid"
                [canEdit]="canEdit"
                [showAdd]="true"
                [showEdit]="true"
                [showDelete]="true"
            ></action-toolbar-buttons>
            <action-toolbar-search name="fluidSearch" [(ngModel)]="grid.filter"></action-toolbar-search>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <wj-flex-grid
            id="mainGrid"
            #mainGrid
            appAutoSize
            (initialized)="grid.initialize(mainGrid)"
            (destroy)="grid.destroy()"
            [itemsSource]="grid.view"
        >
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="'*'" [dataMap]="equipmentDataMap">
                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                    <a [routerLink]="['/equipment/parts-fluids-lookup']" [queryParams]="{ tab: 'equipment', equipment: cell.item.equipment }">{{
                        parent.equipmentDisplay(cell.item.equipment)
                    }}</a>
                </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Fluid Spec'" [binding]="'fluidSpecification'" [width]="'*'">
                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                    @if (cell.item.fluidSpecification) {
                        <a [routerLink]="['/equipment/parts-fluids-lookup']" [queryParams]="{ tab: 'item', item: cell.item.fluidSpecification }">{{
                            cell.item.fluidSpecification
                        }}</a>
                    }
                </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Viscosity'" [binding]="'viscosityGrade'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Gal'" [binding]="'capacityGallons'" [width]="80"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Qt'" [binding]="'capacityQuarts'" [width]="80"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Interval Hrs'" [binding]="'changeIntervalHours'" [width]="100"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Miles'" [binding]="'miles'" [width]="80"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
</div>
